<script>
export default {
  name: "WebsiteContainer",
};
</script>

<template>
  <div class="website-container">
    <router-view />
  </div>
</template>

<style scoped>
.website-container{
  background-color: #F4F5F7;
}
</style>
